import { render, staticRenderFns } from "./PxSelecaoFornecedoresSelecionadosMenu.vue?vue&type=template&id=1ab13133&"
import script from "./PxSelecaoFornecedoresSelecionadosMenu.vue?vue&type=script&lang=js&"
export * from "./PxSelecaoFornecedoresSelecionadosMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VCard,VCardText,VChip,VMenu})
